<template>
	<div class="slideshow-container">
	   <img class="close-btn" src="../assets/close.png" alt="" @click="closeGuideImg">
	  <div class="mySlides fade"  v-if="slideIndex == 1">
	    <img src="../assets/guide_1.png" style="width:100%">
	  </div>
	 
	  <div class="mySlides fade" v-else>
	    <img src="../assets/guide_2.png" style="width:100%">
	  </div>
	  <div class="prev" :class="slideIndex == 2 ? 'active' : ''" @click="plusSlides(1)">
		  <img class="arrow_img" src="../assets/left_arrow.png" alt="" />
	  </div>
	  <div class="next" :class="slideIndex == 1 ? 'active' : ''" @click="plusSlides(2)">
	  	   <img class="arrow_img" src="../assets/right_arrow.png" alt="" />
	  </div>
	
	</div>
</template>

<script>
	export default {
		data(){
			return {
				slideIndex: 1,
				timer: null
			}
		},
		onShow() {
			
		},
		created() {
			
			this.timer = setInterval(()=>{
				let index = this.slideIndex == 1 ? 2 : 1
				this.plusSlides(index)
			},3000)
		},
		methods:{
			plusSlides(n){
				if(this.slideIndex == n){return}
				this.slideIndex = n
			},
			closeGuideImg(){
				if(this.timer) {
					clearInterval(this.timer)
				}
				this.$emit('closeGuideImg')
			}
		}
	}
</script>

<style lang="less">
	.slideshow-container {
	  max-width: 1000px;
	  position: relative;
	  margin: auto;
	  position: fixed;
	  left: 0;
	  right: 0;
	  top: 0;
	  bottom: 0;
	  z-index: 99999;
	  background: rgba(0, 0, 0, 0.6);  
		.close-btn {
			position: fixed;
			right: 16px;
			top: 16px;
			width: 40px;
			height: 40px;
			padding: 10px;
			z-index: 99999;
		}
		.fade {
		  animation-name: fade;
		  animation-duration: 1.5s;
		}
		 
		@keyframes fade {
		  from {opacity: .4} 
		  to {opacity: 1}
		}
		 
		.prev, .next {
		  cursor: pointer;
		  position: absolute;
		  top: 50%;
		  width: auto;
		  padding: 12px 12px 8px 12px;
		  margin-top: -22px;
		  transition: 0.6s ease;
		  user-select: none;
		}
		 
		.next {
		  right: 0;
		  &.active {
		  	background-color: rgba(0, 0, 0, 0.8);
		  }
		}
		 
		.prev {
		  left: 0;
		  &.active {
			background-color: rgba(0, 0, 0, 0.8);
		  }
		}
		.arrow_img {
			width: 26px;
			height: 30px;
		}
	}
	 
	
</style>